import { CheckCircle2, Info, X, XCircle } from "lucide-react";

const VARIANTS = {
  success: {
    icon: CheckCircle2,
    accent: "bg-sage",
    iconColor: "text-sage",
  },
  error: {
    icon: XCircle,
    accent: "bg-brandPurple",
    iconColor: "text-brandPurple",
  },
  info: {
    icon: Info,
    accent: "bg-grey",
    iconColor: "text-grey",
  },
};

function StatusMessage({
  title,
  subtitle,
  variant = "success",
  className = "",
  onDismiss,
}) {
  const { icon: Icon, accent, iconColor } = VARIANTS[variant] || VARIANTS.success;

  return (
    <div
      className={`relative flex items-center gap-3 bg-[#f5f5f5] py-2.5 pl-5 pr-3 font-josefin text-sm ${className}`}
    >
      <div className={`absolute bottom-0 left-0 top-0 w-1 rounded-l-lg ${accent}`} />
      <Icon size={18} className={`${iconColor} shrink-0`} aria-hidden="true" />
      <p className="text-secondaryText">
        <span className="font-bold text-black">{title}</span>
        {subtitle ? (
          <span className="font-normal text-textMuted"> - {subtitle}</span>
        ) : null}
      </p>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="ml-2 shrink-0 rounded p-0.5 text-textMuted transition hover:text-secondaryText"
          aria-label="Fermer"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}

export default StatusMessage;
